// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__26dxx","header":"MessagesList_header__1K3Yq","chat":"MessagesList_chat__dgXHB"};